/**
 * projectMode — V14.62 Sprint 26.
 *
 * Single source of truth for "what kind of project is this?" so the
 * Édition Plan flow can light up the right affordances without scattering
 * the project_type_code string across components.
 *
 * Detection rules :
 *   • Maison individuelle    → project_type_code === 'house_single'
 *   • Appartement seul       → project_type_code === 'apartment_single'
 *   • Multi-lot (résidence,
 *     commercial, autre)     → everything else
 *
 * Add new modes here by extending the constants — never by branching
 * inline in views.
 */

export const PROJECT_MODE = Object.freeze({
  MAISON:     'maison',
  APARTMENT:  'apartment',
  MULTI_LOT:  'multi_lot',
});

export const isMaisonProject = (project) =>
  project?.project_type_code === 'house_single';

export const isApartmentProject = (project) =>
  project?.project_type_code === 'apartment_single';

export const getProjectMode = (project) => {
  if (isMaisonProject(project))    return PROJECT_MODE.MAISON;
  if (isApartmentProject(project)) return PROJECT_MODE.APARTMENT;
  return PROJECT_MODE.MULTI_LOT;
};

export default {
  PROJECT_MODE,
  isMaisonProject,
  isApartmentProject,
  getProjectMode,
};
